<template>
    <v-card outlined class="ma-4 pb-4">
        <v-card-title class="primary white--text py-2 d-flex justify-space-between align-center">
            <span>
                <v-icon left dark small>build</v-icon>
                <span class="subtitle-1">Ferramentas de Administrador</span>
            </span>
            <v-btn text dark small @click="$emit('input', !value)">
                <v-icon left small>{{ value ? "expand_less" : "expand_more" }}</v-icon>
                {{ value ? "Ocultar" : "Mostrar" }} Cabeçalho
            </v-btn>
        </v-card-title>
        <v-card-text class="pt-3 pb-2">
            <div class="d-flex flex-wrap align-center">
                <v-spacer/>
                <v-btn text small color="primary" class="mr-2 mb-2" :href="`/charger/${chargerName}`">
                    <v-icon left small>settings</v-icon>
                    Configurar Carregador
                </v-btn>

                <v-btn v-if="charger.numberPlugs == 1" text small color="error" class="mb-2" @click="clearSession(1)">
                    <v-icon left small>delete</v-icon>
                    Limpar Sessão
                </v-btn>
                <v-menu v-else offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn text small color="error" class="mb-2" v-bind="attrs" v-on="on">
                            <v-icon left small>delete</v-icon>
                            Limpar Sessão
                            <v-icon right small>arrow_drop_down</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item v-for="plug in charger.numberPlugs" :key="plug" @click="clearSession(plug)">
                            <v-list-item-title>Plug {{ plug }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
            <CommandOcpp :chargerName="chargerName" :numberPlugs="charger.numberPlugs" :server="charger.server" v-if="charger.protocol == '1.6'" />
        </v-card-text>

        <ConfirmModal ref="confirm" />
    </v-card>
</template>

<script>
import ConfirmModal from "@/components/core/ConfirmModal";
import CommandOcpp from "@/components/shared/CommandOcpp";

export default {
    props: {
        chargerName: {
            type: String,
            required: true,
        },
        charger: {
            required: true,
        },
        value: {
            type: Boolean,
            default: false,
        },
    },

    components: { ConfirmModal, CommandOcpp },

    methods: {
        clearSession(plug) {
            this.$refs.confirm
                .open("Tem certeza?", "Só faça limpeza de carregamentos com problema. A limpeza de carregamento ativo irá apagar todo os dados e as informações serão perdidas. \n\n PAGAMENTO PODERÁ SER ESTONADO!!!")
                .then((confirm) => {
                    if (confirm) {
                        this.$http
                            .postDynamic(this.charger.server, "api/v2/charger/clear-session", { charger: this.chargerName, plug: plug })
                            .then(() => {
                                this.$emit("update");
                            })
                            .catch((error) => {
                                this.$eventHub.$emit("msgError", error.message ? error.message : "Error ao processar requisição.");
                            });
                    }
                });
        },
    },
};
</script>
